import ProfilePanel from './ProfilePanel'

export default ProfilePanel